const FLAG_URLS = {
  AB: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Flag_of_Alberta.svg/120px-Flag_of_Alberta.svg.png',
  BC: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Flag_of_British_Columbia.svg/120px-Flag_of_British_Columbia.svg.png',
  MB: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Flag_of_Manitoba.svg/120px-Flag_of_Manitoba.svg.png',
  NB: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Flag_of_New_Brunswick.svg/120px-Flag_of_New_Brunswick.svg.png',
  NL: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Newfoundland_and_Labrador.svg/120px-Flag_of_Newfoundland_and_Labrador.svg.png',
  NS: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Flag_of_Nova_Scotia.svg/120px-Flag_of_Nova_Scotia.svg.png',
  ON: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Ontario.svg/120px-Flag_of_Ontario.svg.png',
  PE: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Flag_of_Prince_Edward_Island.svg/120px-Flag_of_Prince_Edward_Island.svg.png',
  SK: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Flag_of_Saskatchewan.svg/120px-Flag_of_Saskatchewan.svg.png',
  NT: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Flag_of_the_Northwest_Territories.svg/120px-Flag_of_the_Northwest_Territories.svg.png',
  YT: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Flag_of_Yukon.svg/120px-Flag_of_Yukon.svg.png',
  NU: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Flag_of_Nunavut.svg/120px-Flag_of_Nunavut.svg.png',
};

const FLAG_ALTS = {
  AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', ON: 'Ontario',
  PE: 'Prince Edward Island', SK: 'Saskatchewan', NT: 'Northwest Territories',
  YT: 'Yukon', NU: 'Nunavut',
};

export function ProvinceFlag({ code, className }) {
  const src = FLAG_URLS[code];
  const alt = FLAG_ALTS[code] || `${code} flag`;
  if (!src) return null;

  return (
    <img
      src={src}
      alt={`${alt} flag`}
      className={className}
      loading="eager"
      decoding="async"
      draggable={false}
      width="120"
      height="80"
      style={{ backgroundColor: '#F4F4F5' }}
    />
  );
}

export { FLAG_URLS };
